import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hk-section" }
const _hoisted_2 = { class: "hk-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_app_bar = _resolveComponent("main-app-bar")!
  const _component_connection_row = _resolveComponent("connection-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_main_app_bar),
      _createVNode(_component_v_main, {
        class: "hk-app-bg",
        style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.baseImg + ')' })
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "hk-heading hk-heading--accent mb-3" }, "Lépj velünk kapcsolatba", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "hk-lead text-center mb-10" }, "Kérdésed van, vagy ajánlatot kérnél? Elérhetőségeink egyikén szívesen segítünk.", -1)),
              _createVNode(_component_v_card, { class: "hk-card pa-4 pa-md-8 mb-8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_connection_row)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, { class: "hk-card map-card" }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("iframe", {
                    class: "map-frame",
                    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1626.1723109460793!2d19.866653731243492!3d46.72773102185655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4743e9006da49731%3A0xce556a9025c7c1cb!2zS3JlYXTDrXYgSMOtbXrFkWt1Y2vDsw!5e0!3m2!1shu!2shu!4v1734196153637!5m2!1shu!2shu",
                    allowfullscreen: "",
                    loading: "lazy",
                    referrerpolicy: "no-referrer-when-downgrade"
                  }, null, -1)
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}